/**
 * Socket.IO notification channel configuration.
 * URL: REACT_APP_SOCKET_URL or REACT_APP_MESSAGE_WSS, else origin of REACT_APP_API (without /api/v1).
 */

export const SOCKET_EVENTS = {
  READY: 'socket:ready',
  NOTIFICATION_NEW: 'notification:new',
};

export const SOCKET_NOTIFICATION_CONFIG = {
  /** Debounce before refetching GET /notifications/count after a push */
  COUNT_REFRESH_DEBOUNCE_MS: 400,
  RECONNECTION_ATTEMPTS: Infinity,
  RECONNECTION_DELAY_MS: 1000,
  RECONNECTION_DELAY_MAX_MS: 10000,
  TIMEOUT_MS: 20000,
};

export const SOCKET_SENTRY_TAGS = { area: 'notification-socket' };

export const SOCKET_SENTRY_STEPS = {
  CONNECT: 'connect',
  HANDLER: 'handler',
  TEARDOWN: 'teardown',
};

/**
 * Origin used by socket.io-client (no /api/v1 path).
 * @returns {string}
 */
export const resolveNotificationSocketUrl = () => {
  const explicit =
    process.env.REACT_APP_SOCKET_URL ||
    process.env.REACT_APP_MESSAGE_WSS ||
    process.env.REACT_APP_API_URL;

  if (explicit) {
    return String(explicit).trim().replace(/\/$/, '');
  }

  const apiBase = process.env.REACT_APP_API || '';
  if (!apiBase) {
    return '';
  }

  try {
    const url = new URL(apiBase);
    return `${url.protocol}//${url.host}`;
  } catch {
    return apiBase.replace(/\/api\/v\d+\/?$/i, '').replace(/\/$/, '');
  }
};
